// libs
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'

// interfaces / constants

// classes / components
import LandingPage from 'src/components/landing_page/landing_page'

// helpers
import { showLoginModal, showRegistrationModal } from 'src/actions/app-state/app-state'

interface IDispatchFromProps {
  showLoginModal: () => void;
  showRegistrationModal: () => void;
}

const mapDispatchToProps: IDispatchFromProps = {
  showLoginModal,
  showRegistrationModal
}

interface IOwnProps {
  page404?: boolean;
  getDefaultRedirectPath: () => string;
}

export default withRouter(
  connect<undefined, IDispatchFromProps, IOwnProps & RouteComponentProps>(
    undefined,
    mapDispatchToProps
  )(LandingPage))
